/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { Box, CircularProgress, Divider, IconButton, Typography } from "@mui/material";
import APIBsc from "libs/apiBsc";
import { iconButtons } from "libs/constans";
import { formatTime, minimizeAddress, urlTransactions } from "libs/utils";
import React, { Fragment, useEffect, useState } from "react";
import { fromWei } from "web3-utils";

type IProps = {
    address: string | undefined,
    contractAddress: string | undefined,
}

export default function History(props: IProps) {
    const { address, contractAddress } = props;

    const [history, setHistory] = useState<any[]>([]);
    const [pending, setPending] = useState(false);
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const api = new APIBsc();

    const getHistory = async (address, page, limit) => {
        setPending(true);
        await api.getTransactions(address, page, limit).then(
            (result) => {
                if (result.result) {
                    setHistory(result.result);
                    console.log(result.result);
                }
            },
            (error) => {
                console.log(error!.message);
            }
        )
        setPending(false);
    }

    const getTokenHistory = async (address, contractAddress, page, limit) => {
        setPending(true);
        await api.getTokenTransfer(address, contractAddress, page, limit).then(
            (result) => {
                if (result.result) {
                    setHistory(result.result);
                    console.log(result.result);
                }
            },
            (error) => {
                console.log(error!.message);
            }
        )
        setPending(false);
    }

    useEffect(() => {
        console.log(address);
        if (address && !contractAddress) {
            getHistory(address, page, limit);
        }
        if (address && contractAddress) {
            getTokenHistory(address, contractAddress, page, limit);
        }
    }, [address, contractAddress, page, limit])

    return (
        <Fragment>
            <Box
                sx={{
                    mt: 1,
                    overflowY: 'auto',
                    maxHeight: '50vh',
                    mx: -2,
                    px: 1,
                }}
            >
                {pending &&
                    <Box sx={{ mt: 3, textAlign: 'center' }}>
                        <CircularProgress size={16} />
                    </Box>
                }
                {history.length === 0 && !pending &&
                    <Box sx={{ mt: 3, textAlign: 'center' }}>
                        <Typography sx={{ fontSize: '13px', color: '#B1BBD2' }}>{`No history available`}</Typography>
                    </Box>
                }
                {history && history.length > 0 && history.map((item, index) => {
                    let type = '';
                    let addr = '';
                    let amount = parseFloat(fromWei(item.value, 'ether')).toFixed(6);
                    let time = formatTime(item.timeStamp);
                    let itemLink = urlTransactions(item.hash);

                    if (String(item.from).toLowerCase() === String(address).toLowerCase()) {
                        type = 'TRANSFER';
                        addr = item.to;
                    }
                    if (String(item.to).toLowerCase() === String(address).toLowerCase()) {
                        type = 'RECEIVE';
                        addr = item.from;
                    }
                    if (type) return <Fragment key={index}>
                        <Divider />
                        <a href={itemLink} target="_blank" rel="noreferrer">
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 1, mb: 1 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <IconButton sx={{ backgroundColor: "#ffffff", width: 30, height: 30, mx: 1 }}>
                                        <object data={iconButtons[type]} width={15} height={15}> </object>
                                    </IconButton>
                                    <Box sx={{ textAlign: 'left' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                textTransform: 'capitalize',
                                            }}
                                        >
                                            {type.toLowerCase()}
                                        </Typography>
                                        <Typography sx={{ fontSize: '13px', fontWeight: '300', color: '#A7A7A7' }}>
                                            {type === 'TRANSFER' ? 'To:' : 'From:'}{minimizeAddress(addr, 8)}
                                        </Typography>
                                        <Typography sx={{ fontSize: '10px', fontWeight: '300', color: '#A7A7A7' }}>
                                            {time}
                                        </Typography>
                                    </Box>
                                </Box>
                                <Box sx={{ textAlign: 'right' }}>
                                    <Typography sx={{ fontSize: '13px' }}>
                                        {type === 'TRANSFER' ? '-' : '+'}{amount} {contractAddress ? item.tokenSymbol : `BNB`}
                                    </Typography>
                                </Box>
                            </Box>
                        </a>
                    </Fragment>
                    return <></>
                })
                }
            </Box>
        </Fragment>
    );
}